import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import paginationComponent from '../../../components/pagination/pagination.component';
import SelectSiteGroupComponent from '../../../components/site/select-site-group.component';
import SelectSiteComponent from '../../../components/site/select-site.component';
import languageModel from '../../../models/language.model';
import PerformanceModel from '../../../models/task-management/performance.model';
import SalesPerformanceWidget from "../../../widgets/sales-performance.widget";
import ViewBase from '../../view-base.view';

export default function SalesPerformanceTargetAchievementsView() {
  ViewBase.call(this);
  let currency = "";
  let lstSalePerformanceDetail = {
    data: [],
    selectedSiteGroups: [],
    selectedSites: [],
    pageIndex: 1,
    pageSize: 10,
    totalSize: 0,
    totalCount: 0
  };

  let inputFilter = { fromMonth: "", toMonth: "" };
  let filter = Object.assign({ PageSize: 10, PageIndex: 1 }, inputFilter);
  let chartFilter = { fromMonth: "", toMonth: "" };

  var events = {
    onSearchDataChanged: (_inputFilter) => { }
  };

  let setDefaultValue = () => {
    lstSalePerformanceDetail.data = [];
    lstSalePerformanceDetail.selectedSites = [];
    lstSalePerformanceDetail.selectedSiteGroups = [];
    inputFilter = { fromMonth: "", toMonth: "" };
    filter = Object.assign({ PageSize: 10, PageIndex: 1 }, inputFilter);
    chartFilter = { fromMonth: "", toMonth: "" };
    inputFilter.fromMonth = moment().subtract(5, 'months').format("YYYY-MM"); // 5 months ago (6 months of records)
    inputFilter.toMonth = moment().format("YYYY-MM"); // Current month 
    inputFilter.site = "";
    inputFilter.siteGroup = "";
    inputFilter.retailDiv = "";
    inputFilter.type = "";
    if (inputFilter.fromMonth.length == 7) {
      filter.fromMonth = inputFilter.fromMonth.replace('-', '');
      chartFilter.fromMonth = inputFilter.fromMonth.replace('-', '');
    }
    if (inputFilter.toMonth.length == 7) {
      filter.toMonth = inputFilter.toMonth.replace('-', '');
      chartFilter.toMonth = inputFilter.toMonth.replace('-', '');
    }
    onSearch();
  }

  let getFilters = () => {
    if (inputFilter.fromMonth.length == 7) {
      filter.fromMonth = inputFilter.fromMonth.replace('-', '');
      chartFilter.fromMonth = inputFilter.fromMonth.replace('-', '');
    }

    if (inputFilter.toMonth.length == 7) {
      filter.toMonth = inputFilter.toMonth.replace('-', '');
      chartFilter.toMonth = inputFilter.toMonth.replace('-', '');
    }

    if (inputFilter.retailDiv != null && inputFilter.retailDiv != "") {
      filter.retailDiv = inputFilter.retailDiv;
      chartFilter.retailDiv = inputFilter.retailDiv;
    }

    if (inputFilter.type != null && inputFilter.type != "") {
      filter.type = inputFilter.type;
      chartFilter.type = inputFilter.type;
    }

    if (lstSalePerformanceDetail.selectedSiteGroups.length > 0) {
      let siteGroupsString = lstSalePerformanceDetail.selectedSiteGroups.map(sg => sg.code).join('^');
      filter.siteGroup = siteGroupsString;
      chartFilter.siteGroup = siteGroupsString;
    } else {
      filter.siteGroup = "";
      chartFilter.siteGroup = "";
    }

    if (lstSalePerformanceDetail.selectedSites.length > 0) {
      let sitesString = lstSalePerformanceDetail.selectedSites.map(s => s.code).join('^')
      filter.site = sitesString;
      chartFilter.site = sitesString;
    } else {
      filter.site = "";
      chartFilter.site = "";
    }
  }

  let onSearch = () => {
    getFilters();
    events.onSearchDataChanged(chartFilter);
    _search();
  }

  let _search = () => {
    this.showLoading();

    PerformanceModel.getSalesPerformancesDetail(filter)
      .then((result) => {
        lstSalePerformanceDetail.data = result.data;
        lstSalePerformanceDetail.totalCount = result.total;
        lstSalePerformanceDetail.pageIndex = result.pageIndex;
        lstSalePerformanceDetail.pageSize = result.pageSize;
        if (lstSalePerformanceDetail.data && lstSalePerformanceDetail.data.length > 0) {
          currency = lstSalePerformanceDetail.data[0].currency;
        } else {
          currency = '';
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    filter.PageIndex = pageIndex;
    filter.PageSize = pageSize;
    _search();
  }

  let onPageChanged = (pageIndex) => {
    filter.PageIndex = pageIndex;
    _search();
  }

  let onClear = () => {
    setDefaultValue();
  }

  let _downloadExcel = () => {
    this.showLoading();

    let fileName = uuidv4();

    PerformanceModel.downloadTargetAchievementsExcel(filter, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  return {
    oninit: (vnode) => {
      setDefaultValue();
    },
    view: (vnode) => {
      return [
        m('.target-achievements',
          //Search
          m('.card.mb-3',
            m('.card-body',
              m('.row.g-4',
                m(".col-sm-6.col-lg-3",
                  m("label.form-label", languageModel.getText("LT00000331", "Sales Month: From")),
                  m("input.form-control.form-control-bg",
                    {
                      "type": "month",
                      "value": inputFilter.fromMonth,
                      onchange: (e) => { inputFilter.fromMonth = e.target.value; }
                    }
                  ),
                ),
                m(".col-sm-6.col-lg-3",
                  m("label.form-label", languageModel.getText("LT00000332", "Sales Month: To")),
                  m("input.form-control.form-control-bg",
                    {
                      "type": "month",
                      "value": inputFilter.toMonth,
                      onchange: (e) => { inputFilter.toMonth = e.target.value; }
                    }
                  ),
                ),
                m('.col-sm-6.col-lg-3',
                  m('label.form-label', this.getText("LT00000072", "Site Group")),
                  m(SelectSiteGroupComponent, {
                    selectedItems: lstSalePerformanceDetail.selectedSiteGroups,
                    onChange: (g) => {
                      lstSalePerformanceDetail.selectedSiteGroups = g;
                    }
                  })
                ),
                m('.col-sm-6.col-lg-3',
                  m('label.form-label', this.getText("LT00000071", "Site")),
                  m(SelectSiteComponent, {
                    selectedItemList: lstSalePerformanceDetail.selectedSites,
                    onChange: (s) => {
                      lstSalePerformanceDetail.selectedSites = s;
                    }
                  })
                ),
                m('.col-12.d-flex.justify-content-end.gap-2',
                  m('button.btn.btn-primary', { onclick: onSearch }, languageModel.getText("LT00000001", "Search")),
                  m('button.btn.btn-white', { onclick: onClear }, languageModel.getText("LT00000031", "Clear")),
                ),
              )
            )
          ),

          //Chart
          lstSalePerformanceDetail.data && lstSalePerformanceDetail.data.length > 0 &&
          m(SalesPerformanceWidget, {
            isDetails: true,
            inputFilter: chartFilter,
            events: events,
            class: 'mb-3'
          }),

          //List
          m('.card',
            m('.card-body',
              m('.d-flex.justify-content-end.mb-2',
                m('a.btn.btn-primary', { onclick: _downloadExcel },
                  m('i.bi.bi-file-earmark-arrow-down-fill'), languageModel.getText("LT00000018", "Excel Download"),
                )
              ),
              m('.row',
                m(".col-12.p-0",
                  m(".table-responsive",
                    m("table.table.table-bordered", [
                      m("thead.thead-bggrey",
                        m("tr.align-middle", [
                          m("th", { "scope": "col" }, languageModel.getText("LT00000240", "Retail Division")),
                          m("th", { "scope": "col" }, languageModel.getText("LT00000071", "Site")),
                          m("th", { "scope": "col", "style": "width: 90px;" }, languageModel.getText("LT00000326", "Month")),
                          m("th", { "scope": "col", "style": "width: 90px;" }, languageModel.getText("LT00000283", "Target") + (_.isEmpty(currency) ? '' : ` (${currency})`)),
                          m("th", { "scope": "col", "style": "width: 90px;" }, languageModel.getText("LT00000284", "Actual") + (_.isEmpty(currency) ? '' : ` (${currency})`)),
                          m("th", { "scope": "col", "style": "width: 140px;" }, languageModel.getText("LT00000333", "Achievement")),
                          m("th", { "scope": "col", "style": "width: 120px;" }, languageModel.getText("LT00000334", "vs Last year"))
                        ])
                      ),
                      m("tbody",
                        lstSalePerformanceDetail.data && lstSalePerformanceDetail.data.length == 0 &&
                        m("tr", { "class": "align-middle" },
                          m("td", { "colspan": "6" }, languageModel.getText("EM00000141", "No records found."))
                        ),
                        lstSalePerformanceDetail.data && lstSalePerformanceDetail.data.map(pd => [
                          m("tr", [
                            m("td", pd.retailDiv),
                            m("td", pd.siteName),
                            m("td", pd.month),
                            m("td.text-end", pd.targetAmt.toLocaleString()),
                            m("td.text-end", pd.actualAmt.toLocaleString()),
                            m("td.text-end", pd.achievement.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%'),
                            m("td.text-end", pd.vsLastYear)
                          ])
                        ]),
                      )
                    ])
                  ),
                  !this.isLoading && m(".px-3",
                    m(paginationComponent, { currentPage: lstSalePerformanceDetail.pageIndex, pageSize: lstSalePerformanceDetail.pageSize, totalItems: lstSalePerformanceDetail.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                  )
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
